import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Folder icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Folder } from '@sravni/design-system-icons'
 *
 * <Folder />
 * ```
 */
var Folder = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Folder", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.445 14.167h6.65M7.445 10.833h6.65M16.603 7.5h-5.388a.833.833 0 0 1-.693-.37L9.35 5.371A.833.833 0 0 0 8.657 5h-3.72c-.922 0-1.667.746-1.667 1.667v9.166c0 .921.745 1.667 1.666 1.667h11.667c.92 0 1.666-.746 1.666-1.667V9.167c0-.921-.745-1.667-1.666-1.667Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.936 5v-.833c0-.921.745-1.667 1.666-1.667h8.333c.921 0 1.667.746 1.667 1.667V7.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Folder };
//# sourceMappingURL=Folder.js.map
